// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3Sqlk","info":"UpdateTermsInfo_info__Q3YXQ"};